/* unplugin-vue-components disabled */import script from "./Ryzz.vue?vue&type=script&lang=ts&setup=true"
export * from "./Ryzz.vue?vue&type=script&lang=ts&setup=true"

import "./Ryzz.vue?vue&type=style&index=0&id=833575d2&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-833575d2"]])

export default __exports__